import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  name: [
    {...makeRule()},
  ],
}

export let formRules = {
  credit: [
    {...makeRule('请输入金额，只允许输入数字', 'number')},
  ],
  userids: [
    {...makeRule('请至少添加一个用户', 'string')},
  ],
  projectid: [
    {...makeRule('请选择项目', 'number')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/user-credit/user-credit.rules.js